import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import { Button } from 'bench-internal-theme';

export const ClientRulesLayout = styled.div`
  display: grid;
  grid-template-rows: 1fr min-content;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

export const ContractorListLayout = styled.div`
  display: grid;
  align-items: center;
  grid-row-gap: 13px;
`;

export const FormFields = styled.div`
  overflow: auto;
`;

export const FormActions = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr;
  column-gap: 16px;
  padding: 8px 24px;
  background-color: ${colors.pearl};
`;

export const InlineInputLayout = styled.div`
  display: grid;
  align-items: center;
  grid-column-gap: 35px;
`;

export const ContractorInput = styled.input`
  width: 100%;
  height: 30px;
  background: #f7f8fa;
  color: ${props => props.color || 'initial'};
  font-size: 14px;
  background: #ffffff;
  border: 1px solid ${props => props.color || '#b8b7b5'};
  border-radius: 1px;

  &:focus {
    border-color: ${props => props.color || '#b8b7b5'};
  }
`;

export const AddContractorWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const AddButton = styled(Button)`
  width: 58px;
  height: 30px;
  margin-left: 8px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4a4b4e;
`;

export const AddContractorErrorWrapper = styled.div`
  margin-top: 5px;
  height: 15px;
`;

export const AddContractorError = styled.div`
  color: #d6382c;
  font-size: 14px;
  font-style: italic;
`;

export const HeaderRow = styled.div`
  display: grid;
  font-size: 12px;
  grid-template-columns: 140px 80px 148px;
  color: #2f3034;
  grid-column-gap: 2px;
  grid-row-gap: 4px;
`;

export const ContractorList = styled.div`
  display: flex-column;
`;

export const ContractorListItem = styled.div`
  display: grid;
  font-size: 12px;
  grid-template-columns: 140px 185px 94px;
  color: #2f3034;
  grid-column-gap: 2px;
  grid-row-gap: 4px;
  margin-bottom: 8px;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
`;
